import TitleEditor from './TitleEditor'
export default TitleEditor



/** WEBPACK FOOTER **
 ** ./src/Editors/TitleEditor/index.js
 **/